<script>
    import { loading } from "./../stores/loading.js";
    import { fade } from "svelte/transition";
    import Spinner from "./Spinner.svelte";
    import { currentUser } from "../stores/user.js";
</script>

<style>
    .overlay {
        position: fixed;
        z-index: 998;
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #33333399;
        color: white;
    }
</style>

{#if $loading.state || ($currentUser && !$currentUser.fromDb)}
    <div class="overlay" transition:fade>
        <Spinner />
        {#if $loading.reason}
            <h2>{$loading.reason}</h2>
        {/if}
    </div>
{/if}
